import React from 'react';
import loginimage from "../../../assets/visibility.png";
import download from "../../../assets/download.png";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import {
    Grid,
} from "@mui/material";

const Invoice = (props) => {
    const { invoice } = props
    return (
        <Grid style={{ background: '#F0F8F9', marginTop: '20px', border: "1px solid #E3E3E3", boxShadow: '0px 3px 6px #A7A7A729', width: '350px', height: '30px' }}>
            <Grid
                style={{
                    display: "flex",
                    alignItems: 'center',
                }}
            >

<Grid style={{ padding: '5px' }}><a href="invoice" style={{ color: '#0D5C75' }}>{invoice}</a></Grid>
                <Grid sx={{ display: 'flex', marginLeft: 'auto' }}>
                <VisibilityOutlinedIcon style={{color:'#0D5C75'}}/>
                    <FileDownloadOutlinedIcon  style={{ marginLeft: '20px', marginRight: '20px',color:'#0D5C75'}}/>
                </Grid>

            </Grid>
        </Grid>

    )
}

export default Invoice;